import React, { useState } from "react";

const TextArea = (props) => {
    const { formInputsProps } = props
    const [textarea, setTextarea] = useState(null);
    return (
        <div className="col-12 form-group">
            <label> {formInputsProps?.formField?.is_mandatory ? '*' : null} {formInputsProps?.formField?.input} </label>
            <textarea className="resize-none" name={formInputsProps?.formField?.input} required={false} value={formInputsProps.formValues[formInputsProps?.formField?.input] = textarea} onChange={ data => setTextarea(data.target.value) } placeholder="Type here..."></textarea>
            {/* <input type="text" name={formInputsProps?.formField?.input} required={false} value={formInputsProps.formValues[formInputsProps?.formField?.input]} onChange={formInputsProps.handleChange} placeholder="Type here..."/> */}
            {
                formInputsProps.formValues[formInputsProps.formField?.input] && !formInputsProps.formErrors[formInputsProps.formField?.input] ? null : 
                <p className="errMsg">{formInputsProps.formErrors[formInputsProps.formField?.input]}</p>
            }
        </div>
    )
}

export default TextArea